import { render, staticRenderFns } from "./ChannelItem.vue?vue&type=template&id=efc13c24&"
import script from "./ChannelItem.vue?vue&type=script&lang=js&"
export * from "./ChannelItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efc13c24')) {
      api.createRecord('efc13c24', component.options)
    } else {
      api.reload('efc13c24', component.options)
    }
    module.hot.accept("./ChannelItem.vue?vue&type=template&id=efc13c24&", function () {
      api.rerender('efc13c24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/ChannelItem.vue"
export default component.exports